// extracted by mini-css-extract-plugin
export default {"splashScr":"splashScreen_splashScr__5EBzc"};